import React from 'react';
import { Calendar, AlertTriangle, Folder } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function Modalidades() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.15
  });
  return <section id="modalidades" className="py-10 md:py-14 bg-[#F6F7F9]" data-id="element-105">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-106">
        <div className="text-center mb-8 md:mb-10" data-id="element-107">
          <span className="font-body text-xs uppercase tracking-widest text-silver-dark mb-3 block" data-id="element-108">
            Modalidades de trabajo
          </span>
          <h2 className="font-heading text-4xl md:text-5xl text-petrol-dark" data-id="element-109">
            Tres formatos, un estándar
          </h2>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 scroll-animate ${isVisible ? 'is-visible' : ''}`} data-id="element-110">
          {/* Card 1 */}
          <div className="bg-white rounded-lg p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow duration-300 relative overflow-hidden" data-id="element-111">
            <div className="absolute top-0 left-0 right-0 h-1 bg-petrol-gradient" data-id="element-112"></div>
            <Calendar className="w-8 h-8 text-silver-dark mb-5" strokeWidth={1.5} data-id="element-113" />
            <h3 className="font-body font-semibold text-2xl text-petrol-dark mb-3" data-id="element-114">
              Retainer mensual
            </h3>
            <p className="font-body text-sm text-gray-600 leading-relaxed mb-5" data-id="element-115">
              Acompañamiento permanente mes a mes. Seguimiento continuo y
              capacidad de respuesta rápida.
            </p>
            <div className="mb-5" data-id="element-116">
              <h4 className="font-body text-xs font-semibold text-petrol-medium uppercase tracking-wider mb-2" data-id="element-117">
                Incluye típicamente
              </h4>
              <p className="font-body text-sm text-gray-500 leading-relaxed" data-id="element-118">
                Radar semanal + alertas, reunión de seguimiento, dossiers on
                demand, actualización de matrices y mapas, soporte a reuniones.
              </p>
            </div>
            <div data-id="element-119">
              <h4 className="font-body text-xs font-semibold text-petrol-medium uppercase tracking-wider mb-2" data-id="element-120">
                Cuándo conviene
              </h4>
              <p className="font-body text-sm text-gray-500 leading-relaxed" data-id="element-121">
                Para organizaciones expuestas a cambios normativos/políticos que
                necesitan continuidad y previsibilidad.
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-lg p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow duration-300 relative overflow-hidden" data-id="element-122">
            <div className="absolute top-0 left-0 right-0 h-1 bg-petrol-gradient" data-id="element-123"></div>
            <AlertTriangle className="w-8 h-8 text-silver-dark mb-5" strokeWidth={1.5} data-id="element-124" />
            <div className="flex items-baseline gap-3 mb-3" data-id="element-125">
              <h3 className="font-body font-semibold text-2xl text-petrol-dark" data-id="element-126">
                War Room
              </h3>
              <span className="font-body text-sm font-medium text-silver-dark bg-lightgray px-2 py-1 rounded" data-id="element-127">
                30–90 días
              </span>
            </div>
            <p className="font-body text-sm text-gray-600 leading-relaxed mb-5" data-id="element-128">
              Modo intensivo tipo sala de situación para coyunturas críticas con
              plazos cortos.
            </p>
            <div className="mb-5" data-id="element-129">
              <h4 className="font-body text-xs font-semibold text-petrol-medium uppercase tracking-wider mb-2" data-id="element-130">
                Incluye típicamente
              </h4>
              <p className="font-body text-sm text-gray-500 leading-relaxed" data-id="element-131">
                Seguimiento casi diario, briefs frecuentes, tablero de hitos,
                coordinación de agenda institucional, documentos de
                intervención.
              </p>
            </div>
            <div data-id="element-132">
              <h4 className="font-body text-xs font-semibold text-petrol-medium uppercase tracking-wider mb-2" data-id="element-133">
                Cuándo conviene
              </h4>
              <p className="font-body text-sm text-gray-500 leading-relaxed" data-id="element-134">
                Cuando hay urgencia y alto impacto, y se necesita foco total por
                un período acotado.
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-lg p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow duration-300 relative overflow-hidden" data-id="element-135">
            <div className="absolute top-0 left-0 right-0 h-1 bg-petrol-gradient" data-id="element-136"></div>
            <Folder className="w-8 h-8 text-silver-dark mb-5" strokeWidth={1.5} data-id="element-137" />
            <h3 className="font-body font-semibold text-2xl text-petrol-dark mb-3" data-id="element-138">
              Proyecto
            </h3>
            <p className="font-body text-sm text-gray-600 leading-relaxed mb-5" data-id="element-139">
              Objetivo específico con entregables cerrados y alcance definido.
            </p>
            <div className="mb-5" data-id="element-140">
              <h4 className="font-body text-xs font-semibold text-petrol-medium uppercase tracking-wider mb-2" data-id="element-141">
                Ejemplos
              </h4>
              <p className="font-body text-sm text-gray-500 leading-relaxed" data-id="element-142">
                Comparativo normativo, plan de incidencia, estrategia de
                implementación, diagnóstico de contingencias.
              </p>
            </div>
            <div data-id="element-143">
              <h4 className="font-body text-xs font-semibold text-petrol-medium uppercase tracking-wider mb-2" data-id="element-144">
                Cuándo conviene
              </h4>
              <p className="font-body text-sm text-gray-500 leading-relaxed" data-id="element-145">
                Para necesidades puntuales con inicio, desarrollo y cierre
                claro.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}